
<div mat-dialog-title>Equivalents cannot be imported<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button></div>
<mat-dialog-content>
  @if (!isUiTest) {
    <div>
      <irb-inventory-grid
        [style.width] = "'100%'"
        [style.height] = "'240px'"
        [showSideBar] = "false"
        [gridOptions] = "gridOptions"
        [frameworkComponents] = 'frameworkComponents'
        [rowData] = 'data.invalidRecords'
      (gridReady) = "onGridReady($event)"></irb-inventory-grid>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
  @if (nonInventoried || unRecognized) {
    <button id="continueButton" (click)="completeImport()" [disabled]="!(data.validRecords?.length > 0)"
    class="btn-medium-primary">Continue</button>
  }
  @if (!(nonInventoried || unRecognized)) {
    <button id="finishButton" (click)="completeImport()" [disabled]="!(data.validRecords?.length > 0)"
    class="btn-medium-primary">Finish</button>
  }
</mat-dialog-actions>
